
export function getFormattedError(error) {
  return Array.isArray(error.errors)
  ? `GraphQL error: ${error.errors.map(({ message }) => message).join(', ')}`
  : (error.message ? `Error loading template: ${error.message}` : 'Error loading template')
}